import { render, staticRenderFns } from "./UpgradeDialog.vue?vue&type=template&id=e5bb711e&"
import script from "./UpgradeDialog.vue?vue&type=script&lang=js&"
export * from "./UpgradeDialog.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpgradeDialog.vue"
export default component.exports